// @ts-nocheck
import * as React from 'react';
import type { RadioGroupProps, RadioButtonProps, OnChangeFunction } from './RadioGroup.types';
import RadioGroupWrapper from './RadioGroup.styles';

const handleOnChange = (onChange: OnChangeFunction, key: string) => (): void => onChange(key);

const RadioButton = ({ label, value, id, index, onChange }: RadioButtonProps) => (
  <span
    htmlFor={id}
    className='radio-container text-option-label'
    onClick={onChange}
    onKeyPress={onChange}
    tabIndex={index}
    role='button'
  >
    <input type='radio' value={value} name='radio' checked={value} readOnly />
    <span className='radiomark' />
    {label}
  </span>
);

const RadioGroup = ({ options, onChange }: RadioGroupProps) => (
  <RadioGroupWrapper className='radio'>
    {options.map((option, i) => (
      <RadioButton
        {...option}
        key={option.key}
        index={i}
        id={option.key}
        onChange={handleOnChange(onChange, option.key)}
      />
    ))}
  </RadioGroupWrapper>
);

export default RadioGroup;
